














































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import { NewReportStore } from "@/store/NewReportStore";
import ReactDatePicker from "react-datepicker";
import { ReactInVue } from "vuera";
import MaskedInput from "vue-masked-input";
import * as _ from "lodash";

@Component({
  components: {
    "react-date-picker": ReactInVue(ReactDatePicker),
    MaskedInput
  }
})
export default class EditReportInfo extends Vue {
  @Prop() report!: any;
  @Prop() canEditReportNumber!: boolean;

  private isCheckingReportNumber: boolean = false;
  private reportNumberRegex = new RegExp(/([A-Z]+)-([0-9]{2})-([0-9]{5})/);
  private reportNumberError: boolean = false;
  private nextReportNumber: string | null = null;
  private report_prefix: string | null = null;
  private oldReportNumber: string | null = null;

  public getReportNumberMask() {
    const prefix = JSON.parse(sessionStorage.getItem("cedoon_user") ?? "").report_number_prefix;
    return prefix.replace("A", "\\A") + "-11-11111";
  }

  public isDateValid(_date) {
    const date = moment(_date);
    return date.isValid();
  }

  public onDateSelected(d) {
    this.report.shipping_date = d;
  }

  public onOrderDateSelected(d) {
    this.report.order_date = d;
  }

  public useReportNumber(num) {
    this.isCheckingReportNumber = false;
    this.nextReportNumber = null;
    this.reportNumberError = false;
    this.report.report_number = num;
  }

  public mounted() {
    console.log("HI");
    this.report_prefix = JSON.parse(sessionStorage.getItem("cedoon_user") ?? "").report_number_prefix;

    if (_.isString(this.report.shipping_date)) {
      this.report.shipping_date = moment(this.report.shipping_date).toDate();
    }

    if (_.isString(this.report.order_date)) {
      this.report.order_date = moment(this.report.order_date).toDate();
    } else if (!this.report.order_date) {
      this.report.order_date = undefined;
    }

    if (this.canEditReportNumber) {
      NewReportStore.checkReportNumber({ reportNumber: null })
        .then(response => {
          console.log("initial checkReportNumber call");
          if (response) {
            this.oldReportNumber = response;
            this.report.report_number = response;
          }
        })
        .catch(e => alert(e));
    }
  }

  @Watch("report", { deep: true })
  public onReportChanged() {
    if (this.canEditReportNumber) {
      if (
        this.report.report_number.match(this.reportNumberRegex) &&
        this.oldReportNumber !== this.report.report_number
      ) {
        console.log("will check report number");
        this.isCheckingReportNumber = true;

        NewReportStore.checkReportNumber({ reportNumber: this.report.report_number })
          .then(response => {
            this.isCheckingReportNumber = false;
            this.nextReportNumber = null;
            this.reportNumberError = false;

            if (response !== "success") {
              this.reportNumberError = true;
              this.nextReportNumber = response;
            }
          })
          .catch(error => {
            this.isCheckingReportNumber = false;
            alert(error);
          });
      }

      if (this.oldReportNumber !== this.report.report_number) {
        this.oldReportNumber = this.report.report_number;
      }
    }
  }
}
